
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq-delete-account",
      function () {
        return require("private-next-pages/faq-delete-account/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq-delete-account"])
      });
    }
  